<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/Dk0tiX/tc-custom/9781464210570.jpg?1730581087775" alt="This image is the cover for the book Murder and Mendelssohn, Miss Fisher's Murder Mysteries"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Murder and Mendelssohn, Miss Fisher's Murder Mysteries
      </h1>
      <p class="bookDescription body article font2">
        <p><b>From the author of the bestselling Phryne Fisher Series comes <i>Murder and Mendelssohn</i>, the next murder mystery novel featuring the unstoppable, elegant amateur sleuth. To the accompaniment of heavenly choirs singing, the fearless Miss Fisher returns in her 20th adventure with musical score in hand.</b></p><p>"Like her heroine, Greenwood has never been more confident and confronting..."—<i>Sydney Morning Herald</i></p><p>A master of Australian historical fiction, Kerry Greenwood's bestseller mystery books are:</p>Perfect for Fans of Rhys Bowen and Jacqueline WinspearInspired the Netflix show Miss Fisher's Murder MysteriesMovie Miss Fisher and the Crypt of Tears Currently Streaming on Acorn TV<p>An orchestral conductor has been found dead and Detective Inspector Jack Robinson needs the delightfully incisive and sophisticated Miss Fisher's assistance to enter a world in which he is truly lost. Hugh Tregennis, not much liked by anyone, has been murdered in a most flamboyant mode by a killer with a point to prove. But how many killers is Phryne really stalking?</p><p>At the same time, the dark curls, disdainful air and the lavender eyes of mathematician and code-breaker Rupert Sheffield are taking Melbourne by storm. They've certainly taken the heart of Phryne's old friend from the trenches of WWI, John Wilson. Phryne recognizes Sheffield as a man who attracts danger and is determined to protect John from harm. Even with the faithful Dot, Mr. and Mrs. Butler, and all in her household ready to pull their weight, Phryne's task is complex. While Mendelssohn's Elijah, memories of the Great War, and the science of deduction ring in her head, Phryne's past must also play its part as MI6 become involved in the tangled web of murders.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Kerry Greenwood
      </h2>
      
      <p class="authorDescription body article"><P>Kerry Greenwood was born in the Melbourne suburb of Footscray and after wandering far and wide, she returned to live there. She has degrees in English and Law from Melbourne University and was admitted to the legal profession on the 1st April 1982, a day which she finds both soothing and significant. Kerry has written three series, a number of plays, including The Troubadours with Stephen D’Arcy, is an award-winning children’s writer and has edited and contributed to several anthologies. The Phryne Fisher series (pronounced Fry-knee, to rhyme with briny) began in 1989 with Cocaine Blues which was a great success. Kerry has written twenty books in this series with no sign yet of Miss Fisher hanging up her pearl-handled pistol. Kerry says that as long as people want to read them, she can keep writing them. In 2003 Kerry won the Lifetime Achievement Award from the Australian Association.</P></p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Poisoned Pen Press
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?5ff833fe